import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

export interface IAuthData {
	token: string;
	centrifugo_channel?: string;
}

type JwtPayload = {
	exp?: number;
};

const isBrowserSecure = () => typeof window !== 'undefined' && window.location.protocol === 'https:';

const BASE_COOKIE_OPTIONS = {
	path: '/',
	sameSite: 'lax' as const,
	secure: isBrowserSecure(),
};

const getFromStorage = (key: string) => {
	if (typeof window === 'undefined') return '';
	return localStorage.getItem(key) || '';
};

const getExpirationDate = (token?: string) => {
	if (!token) return undefined;

	try {
		const decoded = jwtDecode<JwtPayload>(token);
		return decoded.exp ? new Date(decoded.exp * 1000) : undefined;
	} catch (error) {
		return undefined;
	}
};

export function getAuth() {
	return {
		token: Cookies.get('token') || getFromStorage('token') || '',
		centrifugo_channel: Cookies.get('centrifugo_channel') || getFromStorage('centrifugo_channel') || '',
	};
}

export function saveAuth(data: IAuthData) {
	const expires = getExpirationDate(data.token);
	const cookieOptions = expires ? { ...BASE_COOKIE_OPTIONS, expires } : BASE_COOKIE_OPTIONS;

	Cookies.set('token', data.token, cookieOptions);
	Cookies.set('centrifugo_channel', data.centrifugo_channel, cookieOptions);

	if (typeof window !== 'undefined') {
		localStorage.setItem('token', data.token);
		data.centrifugo_channel && localStorage.setItem('centrifugo_channel', data.centrifugo_channel);
	}
}

export function removeAuth() {
	Cookies.remove('token');
	Cookies.remove('centrifugo_channel');

	if (typeof window !== 'undefined') {
		localStorage.removeItem('token');
		localStorage.removeItem('centrifugo_channel');
	}
}
